module.exports = __webpack_public_path__ + "static/dessert200-a03799332b7e9bbe8d2c4045758fd8b5.png";